import dayjs, { Dayjs } from 'dayjs';
import { stringIsNullOrEmpty } from '../util/helpers/stringHelpers.ts';

//NOTE: Don't export these. Use methods. Then we are not tied to dayJS everywhere
const formatters = {
  momentDate: 'M/D/YYYY',
  momentDateTimeUSA: 'DD-MMM-YYYY h:mm A',
  momentDateTimeUSANoTime: 'DD-MMM-YYYY',
  momentDateNoYear: 'DD MMM',

  momentDayMonthYear: 'DD/MM/YYYY',

  momentDateDefault: 'DD-MMM-YYYY',
  momentDateShortDefaultNoYear: 'MMM DD',
  momentDateTimeDefault: 'DD-MMM-YYYY h:mm A'
};

export const formatDateDayJs = (date: Dayjs | undefined) => {
  if (!date) {
    return '';
  }
  return date.format(formatters.momentDateDefault);
};

export const formatTravelportDateTime = (date: string) => {
  if (stringIsNullOrEmpty(date)) {
    return '';
  }
  return dayjs(date).format(formatters.momentDateTimeUSA);
};

export const formatDate = (date: string | undefined) => {
  if (stringIsNullOrEmpty(date)) {
    return '';
  }
  return dayjs(date, formatters.momentDate).format(formatters.momentDateDefault);
};

export const formatDateTime = (date: string | undefined) => {
  if (stringIsNullOrEmpty(date)) {
    return '';
  }
  let dateForFormat = date;
  if (date.indexOf('Z') < 0) {
    dateForFormat = date + 'Z';
  }
  return dayjs(dateForFormat, formatters.momentDate).format(formatters.momentDateTimeDefault);
};

// Handles ISO date-time strings that may already include timezone offsets (e.g. +00:00).
export const formatDateTimeWithTimezone = (date: string | undefined) => {
  if (stringIsNullOrEmpty(date)) {
    return '';
  }

  const hasTimezone = /([zZ]|[+-]\d{2}:\d{2})$/.test(date);
  const dateForFormat = hasTimezone ? date : `${date}Z`;
  const parsed = dayjs(dateForFormat);
  if (!parsed.isValid()) {
    return '';
  }
  return parsed.format(formatters.momentDateDefault);
};

export const formatDateTimeDayJs = (date: Dayjs | undefined) => {
  if (!date) {
    return '';
  }
  return dayjs(date, formatters.momentDate).format(formatters.momentDateTimeDefault);
};

export const formatDateNoYear = (date: string | undefined) => {
  if (stringIsNullOrEmpty(date)) {
    return '';
  }
  return dayjs(date, formatters.momentDate).format(formatters.momentDateShortDefaultNoYear);
};
